<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>View Rides</h2>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive">
              <table id="all-rides" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th>#</th>
                  <th>Class</th>
                  <th>Chasis Number</th>
                  <th>Registration Number</th>
                  <th>Registration State</th>
                  <th>Purchase year</th>
                  <th>Details</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th>#</th>
                  <th>Class</th>
                  <th>Chasis Number</th>
                  <th>Registration Number</th>
                  <th>Registration State</th>
                  <th>Purchase year</th>
                  <th>Details</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let ride of allRides;let i = index;">

                  <td>{{ i + 1 }}</td>
                  <td>&nbsp;
                    {{ ride?.okada_class }}
                  </td>
                  <td>{{ ride?.chasis_number }}</td>
                  <td>{{ ride?.registration_number }}</td>
                  <td>{{ ride?.registration_state?.name }}</td>
                  <td>{{ ride?.purchase_year }}</td>
                  <td class="text-center">
                    <div>
                      <span role="button" data-balloon="View Riders" data-balloon-pos="up" (click)="viewAllRiders(ride)">
                        <i class="fa fa-eye text-info"></i>
                      </span>

                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>






<!-- View Riders Details -->
<!-- The Modal -->
<div class="modal fade" id="riderDetails">
  <div class="modal-dialog modal-lg" *ngIf="isRiderInfo">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Riders Information</h4>
        <button type="button" class="close" data-dismiss="modal"  (click)="closeInformation()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover" *ngFor="let viewThisRider of viewRiders">
            <tr>
              <th>First Name</th><td>{{viewThisRider?.first_name}}</td>
              <th>Last Name</th><td>{{viewThisRider?.last_name}}</td>
            </tr>

            <tr>
              <th>Email</th><td>{{viewThisRider?.email}}</td>
              <th>Phone Number</th><td>{{viewThisRider?.phone_no}}</td>
            </tr>
            <tr>
              <th>DOB</th> <td>{{viewThisRider?.dob | date}}</td>
              <th>Gender</th><td>{{viewThisRider?.gender}}</td>
            </tr>
            <tr>
              <th>Nationality</th><td>{{viewThisRider?.nationality}}</td>
              <th >Marital Status</th>
              <td >{{ viewThisRider?.marital_status }}</td>

            </tr>
            <tr>
              <th >State of Origin</th>
              <td >{{ viewThisRider?.state_of_origin?.name }}</td>
              <th >LGA of Origin</th>
              <td >{{ viewThisRider?.lga_of_origin?.name }}</td>

            </tr>

            <tr>
              <th >Residential Address</th>
              <td >{{ viewThisRider?.residential_address }}</td>
              <th >NIMC Number</th>
              <td >{{ viewThisRider?.nimc_no }}</td>

            </tr>
            <tr>
              <th >Enrollment Payment Status</th>
              <td >{{ viewThisRider?.enrollment_pmt_status }}</td>
              <th >Driving Test Status</th>
              <td [ngClass]="viewThisRider.driving_test_status === 'Fail' ? 'text-danger': 'text-success'">{{ viewThisRider?.driving_test_status }}</td>

            </tr>

            <tr>
              <th >Bank Name</th>
              <td >{{ viewThisRider?.bank?.bank_name }}</td>
              <th >Account Number</th>
              <td >{{ viewThisRider?.account_no}}</td>

            </tr>
            <tr>
              <th >BVN</th>
              <td >{{ viewThisRider?.bvn}}</td>
              <th >Operation State</th>
              <td >{{ viewThisRider?.operation_state?.name}}</td>
            </tr>
            <tr>
              <th >Operation LGA</th>
              <td >{{ viewThisRider?.operation_lga?.name}}</td>
              <th >Operation Town</th>
              <td >{{ viewThisRider?.operation_town}}</td>

            </tr>
            <tr>
              <th >Operation Locality</th>
              <td >{{ viewThisRider?.operation_locality}}</td>
              <th >Association Name</th>
              <td >{{ viewThisRider?.association_name}}</td>

            </tr>
            <tr>
              <th >Association Address</th>
              <td >{{ viewThisRider?.association_address}}</td>
              <th >Agent Name</th>
              <td >{{ viewThisRider?.agent?.first_name + " " +viewThisRider?.agent?.last_name}}</td>

            </tr>


          </table>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer" >
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeInformation()">Close</button>
      </div>

    </div>
  </div>
</div>
